module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapsible",
    class: _vm.stateClass,
    attrs: {
      "id": "manip-fluide"
    }
  }, [_c('div', {
    staticClass: "collapsible-head wrap",
    attrs: {
      "id": "head-manip-fluide"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('openCollapsible', 'manip-fluide')
      }
    }
  }, [_vm._v("\n        MANIPULATION DE FLUIDE FRIGORIGÈNE\n        "), _c('i', {
    staticClass: "icon-go"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapsible-body manip wrap"
  }, [_c('div', {
    staticClass: "op-bouteille"
  }, [_c('ul', {
    staticClass: "op-fiche"
  }, _vm._l((_vm.ops), function(op) {
    return _c('operation-component', {
      key: op.id,
      attrs: {
        "operation": op
      },
      on: {
        "opDeleted": _vm.deleteOp
      }
    })
  }), 1), _vm._v(" "), _c('a', {
    staticClass: "btn add-manip",
    attrs: {
      "href": "javascript: void 0",
      "id": "op-fiche"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.recordOperation($event)
      }
    }
  }, [_vm._v("\n                NOUVELLE MANIP\n                "), _c('i', {
    staticClass: "icon-add"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a1a594f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/subcomponents/ManipFluide.vue
// module id = 759
// module chunks = 0